import { render } from "./KnotBoard.vue?vue&type=template&id=6cf51be8&scoped=true"
import script from "./KnotBoard.vue?vue&type=script&lang=js"
export * from "./KnotBoard.vue?vue&type=script&lang=js"

import "./KnotBoard.vue?vue&type=style&index=0&id=6cf51be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf51be8"]])

export default __exports__